import { Add, DoneOutlined, Edit, ImportExport, Person, Settings } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, Grid, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';

interface DashboardCard {
    title: string;
    icon: ReactNode;
    path: string;
    description: string;
}

const adminControlCards = [
    {
        title: 'Accept Applications',
        icon: <DoneOutlined sx={{ fontSize: 40 }} />,
        path: '/admin/accept-applications',
        description: 'Review and process job applications'
    },
    {
        title: 'Server Settings',
        icon: <Settings sx={{ fontSize: 40 }} />,
        path: '/admin/server-settings',
        description: 'Configure system settings and preferences'
    }
];

const dataManagementCards = [
    {
        title: 'User Management',
        icon: <Person sx={{ fontSize: 40 }} />,
        path: '/admin/users',
        description: 'Manage user accounts and permissions'
    },
    {
        title: 'Create Job',
        icon: <Add sx={{ fontSize: 40 }} />,
        path: '/admin/create-job',
        description: 'Create new job postings'
    },
    {
        title: 'Update Job',
        icon: <Edit sx={{ fontSize: 40 }} />,
        path: '/admin/update-job',
        description: 'Modify existing job postings'
    },
    {
        title: 'Import Data',
        icon: <ImportExport sx={{ fontSize: 40 }} />,
        path: '/admin/import-data',
        description: 'Import and export system data'
    }
];

const AdminPanelDashboard = () => {
    const navigate = useNavigate();

    const renderCard = (card: DashboardCard) => (
        <Grid item xs={12} sm={6} md={4} key={card.path}>
            <Card
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'transform 0.2s',
                    '&:hover': {
                        transform: 'scale(1.02)',
                        boxShadow: 6
                    }
                }}
            >
                <CardActionArea
                    onClick={() => navigate(card.path)}
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: 3
                    }}
                >
                    <Box sx={{ color: 'primary.main', mb: 2 }}>
                        {card.icon}
                    </Box>
                    <CardContent sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" component="div" gutterBottom>
                            {card.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {card.description}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );

    return (
        <Stack gap={4} py={2}>
            <Typography variant="h4" gutterBottom sx={{ mb: 2 }}>
                Admin Dashboard
            </Typography>

            <Stack gap={2}>
                <Typography variant="h6" >
                    Data Management
                </Typography>
                <Grid container spacing={3}>
                    {dataManagementCards.map(renderCard)}
                </Grid>
            </Stack>

            <Stack gap={2}>
                <Typography variant="h6" >
                    Admin Control
                </Typography>
                <Grid container spacing={3}>
                    {adminControlCards.map(renderCard)}
                </Grid>
            </Stack>

        </Stack>
    );
};

export default AdminPanelDashboard; 